import React from "react";
import { Link } from "react-router-dom";

export default function ShowSocial({ showData }) {
  return (
    <>
      {(showData?.twitter ||
        showData?.instagram ||
        showData?.tiktok ||
        showData?.facebook) && (
        <div className={"show-social"}>
          {showData?.twitter && (
            <div>
              <Link to={showData?.twitter} target={"_blank"}>
                <img src={"/img/ico/x.png"} alt={"X"} />
              </Link>
            </div>
          )}
          {showData?.instagram && (
            <div>
              <Link to={showData?.instagram} target={"_blank"}>
                <img src={"/img/ico/ig.png"} alt={"Instagram"} />
              </Link>
            </div>
          )}
          {showData?.facebook && (
            <div>
              <Link to={showData?.facebook} target={"_blank"}>
                <img src={"/img/ico/fb.png"} alt={"Facebook"} />
              </Link>
            </div>
          )}
          {showData?.tiktok && (
            <div>
              <Link to={showData?.tiktok} target={"_blank"}>
                <img src={"/img/ico/tiktok.png"} alt={"TikTok"} />
              </Link>
            </div>
          )}
        </div>
      )}
    </>
  );
}
